import { render, staticRenderFns } from "./ChatGptMCPSetup.vue?vue&type=template&id=e2deae0c&scoped=true"
import script from "./ChatGptMCPSetup.vue?vue&type=script&lang=js"
export * from "./ChatGptMCPSetup.vue?vue&type=script&lang=js"
import style0 from "./ChatGptMCPSetup.vue?vue&type=style&index=0&id=e2deae0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2deae0c",
  null
  
)

export default component.exports